"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var _APVerticalScroller = _interopRequireDefault(require("../common/APVerticalScroller/APVerticalScroller"));
var _APInlineButton = _interopRequireDefault(require("../common/APInlineButton"));
var _BulkCancelButtonsComponent = _interopRequireDefault(require("./BulkCancelButtonsComponent/BulkCancelButtonsComponent"));
var _cssClassesHelper = require("../../helpers/cssClassesHelper");
var _browserHelper = require("../../helpers/browserHelper");
var _Level2DataTableComponent = _interopRequireDefault(require("./Level2DataTableComponent"));
require("../../styles/components/TradeComponent.css");
require("./OrderBookComponent.css");
var _APIcon = _interopRequireDefault(require("../../../lib/components/common/APIcon"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var tradeComponentClasses = (0, _cssClassesHelper.getBEMClasses)('trade-component');
var orderBookClasses = (0, _cssClassesHelper.getBEMClasses)('orderbook');
var flexTable = (0, _cssClassesHelper.getBEMClasses)('flex-table');
var OrderBookComponent = /*#__PURE__*/function (_React$Component) {
  function OrderBookComponent(props) {
    var _this;
    _classCallCheck(this, OrderBookComponent);
    _this = _callSuper(this, OrderBookComponent, [props]);
    // default state
    _defineProperty(_this, "resizeEventListener", function () {
      return _this.onClickCenter(true);
    });
    _this.state = {
      showCenterButton: false,
      //  will change to true when user scrolls away from rest position
      viewMode: localStorage.getItem('orderBookViewMode') || 'both'
    };
    // event handler bindings
    _this.onClickCenter = _this.onClickCenter.bind(_this);
    _this.resizeEventListener = _this.resizeEventListener.bind(_this);
    _this.onScrollRestChange = _this.onScrollRestChange.bind(_this);
    _this.handleScrollRestChange = _this.handleScrollRestChange.bind(_this);
    _this.buyScroller = /*#__PURE__*/_react["default"].createRef();
    _this.sellScroller = /*#__PURE__*/_react["default"].createRef();
    return _this;
  }
  _inherits(OrderBookComponent, _React$Component);
  return _createClass(OrderBookComponent, [{
    key: "onClickCenter",
    value: function onClickCenter() {
      var _this2 = this;
      var overrideUserScrolled = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      if (this.sellScroller.current && this.buyScroller.current) {
        var scrollToRest = function scrollToRest() {
          _this2.sellScroller.current.scrollToRest();
          _this2.buyScroller.current.scrollToRest();
        };
        if (overrideUserScrolled) return this.sellScroller.current.resetUserScrolled(function () {
          return _this2.buyScroller.current.resetUserScrolled(scrollToRest);
        });
        scrollToRest();
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      this.onClickCenter(this.props.selectedInstrumentId !== prevProps.selectedInstrumentId);
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      window.addEventListener('resize', this.resizeEventListener);
      this.onClickCenter();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.resizeEventListener);
    }
  }, {
    key: "onScrollRestChange",
    value: function onScrollRestChange() {
      // show "center" button when user scrolls away from rest position
      setTimeout(this.handleScrollRestChange, 230);
    }
  }, {
    key: "handleScrollRestChange",
    value: function handleScrollRestChange() {
      if (this.sellScroller.current) {
        var sellIsAtRest = this.sellScroller.current.getIsAtRest();
        var buyIsAtRest = this.buyScroller.current.getIsAtRest();
        var showCenterButton = !sellIsAtRest || !buyIsAtRest;
        this.setState({
          showCenterButton: showCenterButton
        });
      }
    }
  }, {
    key: "setViewMode",
    value: function setViewMode(mode) {
      localStorage.setItem('orderBookViewMode', mode);
      if (mode === 'buy') {
        this.sellScroller.current = null;
      } else if (mode === 'sell') {
        this.buyScroller.current = null;
      }
      this.setState({
        viewMode: mode
      });
    }
  }, {
    key: "renderCenterButton",
    value: function renderCenterButton() {
      var _this3 = this;
      var _this$props = this.props,
        t = _this$props.t,
        spread = _this$props.spread;
      var showCenterButton = this.state.showCenterButton;
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: orderBookClasses('spread-row')
      }, /*#__PURE__*/_react["default"].createElement("span", null, t('Spread'), " ", spread), showCenterButton && /*#__PURE__*/_react["default"].createElement(_APInlineButton["default"], {
        icon: "center",
        iconModifier: "small",
        text: t('Center'),
        onClick: function onClick() {
          return _this3.onClickCenter(true);
        },
        customClass: orderBookClasses('center-button')
      }));
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;
      var t = this.props.t;
      var onScrollRestChange = this.onScrollRestChange,
        _this$props2 = this.props,
        cancelAllOrders = _this$props2.cancelAllOrders,
        cancelBuyOrders = _this$props2.cancelBuyOrders,
        cancelSellOrders = _this$props2.cancelSellOrders,
        openOrders = _this$props2.openOrders,
        buyOpenOrders = _this$props2.buyOpenOrders,
        sellOpenOrders = _this$props2.sellOpenOrders;
      var _this$props3 = this.props,
        selectedInstrument = _this$props3.selectedInstrument,
        cancelOrders = _this$props3.cancelOrders,
        _this$props3$level = _this$props3.level2,
        buy = _this$props3$level.buy,
        sell = _this$props3$level.sell,
        buyPriceClicked = _this$props3.buyPriceClicked,
        buyQuantityClicked = _this$props3.buyQuantityClicked,
        sellPriceClicked = _this$props3.sellPriceClicked,
        sellQuantityClicked = _this$props3.sellQuantityClicked,
        fetching = _this$props3.fetching,
        hideBulkCancelButtons = _this$props3.hideBulkCancelButtons;
      var viewMode = this.state.viewMode;
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: tradeComponentClasses()
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: orderBookClasses('view-toggles')
      }, /*#__PURE__*/_react["default"].createElement("button", {
        title: t('Both Orders'),
        className: "".concat(orderBookClasses('toggle-button'), " ").concat(viewMode === 'both' ? 'active' : ''),
        onClick: function onClick() {
          return _this4.setViewMode('both');
        }
      }, /*#__PURE__*/_react["default"].createElement(_APIcon["default"], {
        name: "orderbook-both"
      })), /*#__PURE__*/_react["default"].createElement("button", {
        title: t('Buy Orders'),
        className: "".concat(orderBookClasses('toggle-button'), " ").concat(viewMode === 'buy' ? 'active' : ''),
        onClick: function onClick() {
          return _this4.setViewMode('buy');
        }
      }, /*#__PURE__*/_react["default"].createElement(_APIcon["default"], {
        name: "orderbook-buy"
      })), /*#__PURE__*/_react["default"].createElement("button", {
        title: t('Sell Orders'),
        className: "".concat(orderBookClasses('toggle-button'), " ").concat(viewMode === 'sell' ? 'active' : ''),
        onClick: function onClick() {
          return _this4.setViewMode('sell');
        }
      }, /*#__PURE__*/_react["default"].createElement(_APIcon["default"], {
        name: "orderbook-sell"
      }))), /*#__PURE__*/_react["default"].createElement("div", {
        className: "".concat(flexTable(), " ").concat(orderBookClasses(), " view-mode--").concat(viewMode)
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "".concat(flexTable('body'), " ").concat(orderBookClasses('body'))
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "".concat(flexTable('header', 'background'), " ").concat(orderBookClasses('header'))
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: flexTable('column')
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "".concat(flexTable('fixed'), " ").concat(orderBookClasses('table-header', 'price'))
      }, t('Price'))), /*#__PURE__*/_react["default"].createElement("div", {
        className: flexTable('column')
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "".concat(flexTable('fixed'), " ").concat(orderBookClasses('table-header', 'qty'))
      }, t('Qty')))), /*#__PURE__*/_react["default"].createElement("div", {
        className: orderBookClasses('order-book-body')
      }, viewMode !== 'buy' && /*#__PURE__*/_react["default"].createElement(_APVerticalScroller["default"], {
        ref: this.sellScroller,
        restPosition: "bottom",
        onScrollRestChange: onScrollRestChange,
        customClass: orderBookClasses('vertical-scroller-body', (0, _browserHelper.isFirefox)() ? 'firefox' : '')
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "orderbook__table-filler"
      }, /*#__PURE__*/_react["default"].createElement(_Level2DataTableComponent["default"], {
        quantityDecimalPlaces: this.props.convertedQuantityIncrement,
        priceDecimalPlaces: this.props.convertedPriceIncrement,
        selectedInstrument: selectedInstrument,
        cancelOrders: cancelOrders,
        onPriceClick: sellPriceClicked,
        onQuantityClick: sellQuantityClicked,
        level2Data: sell,
        classModifier: 'sell',
        fetching: fetching
      }))), viewMode === 'both' && this.renderCenterButton(), viewMode !== 'sell' && /*#__PURE__*/_react["default"].createElement(_APVerticalScroller["default"], {
        ref: this.buyScroller,
        restPosition: "top",
        onScrollRestChange: onScrollRestChange,
        customClass: orderBookClasses('vertical-scroller-body', (0, _browserHelper.isFirefox)() ? 'firefox' : '')
      }, /*#__PURE__*/_react["default"].createElement(_Level2DataTableComponent["default"], {
        quantityDecimalPlaces: this.props.convertedQuantityIncrement,
        priceDecimalPlaces: this.props.convertedPriceIncrement,
        selectedInstrument: selectedInstrument,
        cancelOrders: cancelOrders,
        onPriceClick: buyPriceClicked,
        onQuantityClick: buyQuantityClicked,
        level2Data: buy,
        classModifier: 'buy',
        fetching: fetching
      })), !hideBulkCancelButtons && /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_BulkCancelButtonsComponent["default"], {
        openOrders: openOrders,
        buyOpenOrders: buyOpenOrders,
        sellOpenOrders: sellOpenOrders,
        cancelAllOrders: cancelAllOrders,
        cancelBuyOrders: cancelBuyOrders,
        cancelSellOrders: cancelSellOrders
      }))))));
    }
  }]);
}(_react["default"].Component);
OrderBookComponent.defaultProps = {
  hideBulkCancelButtons: false,
  level2: {
    buy: [],
    sell: [],
    "short": [],
    unknown: []
  }
};
var _default = exports["default"] = (0, _reactI18next.withTranslation)('order')(OrderBookComponent);